import { MappedLearningOpportunity } from "@/server/backend-api";

export async function joinLearningOppWithSimplifiedProcess(
  learningOpp: MappedLearningOpportunity
) {
  const resp = await fetch("/api/admission/apply", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: learningOpp.id,
      fileNames: [],
    }),
  });

  if (!resp.ok) {
    throw new Error(
      `/api/admission/apply responded with status code ${resp.status}`
    );
  }
}
